export function isRunningInCypress() {
  // @ts-ignore
  return typeof window !== 'undefined' && typeof window.Cypress !== 'undefined';
}
